import React from 'react';
import { Link } from 'react-router-dom';
import StepOne from "../assets/images/one.png";
import StepTwo from "../assets/images/two.png";
import StepThree from "../assets/images/three.png";
import StepFour from "../assets/images/four.png";
import StepFive from "../assets/images/five.png";

function HomeSidebar() {
  return (
    <div className="home-sidebar">
      <h2 className="home-heading">Steps</h2>
      <ul style={{ listStyleType: 'none', padding: 0 }}>
        <li className="sidebar-item">
          <Link to="/maps">
            <img src={StepOne} alt="Step 1" style={{ width: '50px', height: '50px' }} />
          </Link>
          <p>Step 1: Select Service Area</p>
        </li>
        <li className="sidebar-item">
          <Link to="/services">
            <img src={StepTwo} alt="Step 2" style={{ width: '50px', height: '50px' }} />
          </Link>
          <p>Step 2: Select Services</p>
        </li>
        <li className="sidebar-item">
          <Link to="/dronepayload">
            <img src={StepThree} alt="Step 3" style={{ width: '50px', height: '50px' }} />
          </Link>
          <p>Step 3: Select Drone & Payload</p>
        </li>
        <li className="sidebar-item">
          <Link to="/list">
            <img src={StepFour} alt="Step 4" style={{ width: '50px', height: '50px' }} />
          </Link>
          <p>Step 4: Company Information</p>
        </li>
        <li className="sidebar-item">
          <Link to="/termsofuse">
            <img src={StepFive} alt="Step 5" style={{ width: '50px', height: '50px' }} />
          </Link>
          <p>Step 5: Accept the Terms of Use.</p>
        </li>
      </ul>
    </div>
  );
}

export default HomeSidebar;
